<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>菜单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content_top">
        <router-link :to="{path:'/menu/add'}">
          <el-button size="small" type="primary" icon="el-icon-circle-plus-outline">添加菜单</el-button>
        </router-link>
      </div>
      <div class="content">
        <el-table
          :data="menuList"
          style="width: 100%;margin-bottom: 20px;"
          row-key="id"
          border
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column prop="menu_name" label="菜单名"></el-table-column>
          <el-table-column prop="url" label="URL" align="center"></el-table-column>
          <el-table-column prop="level" label="层级" align="center"></el-table-column>
          <el-table-column label="菜单状态" align="center">
            <template slot-scope="scope">{{ scope.row.is_show == 0 ? "隐藏" : "显示" }}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="220">
            <template slot-scope="scope">
              <router-link :to="{ path : '/menu/update', query:{ id: scope.row.id}}">
                <el-button type="text" icon="el-icon-edit">修改</el-button>
              </router-link>
              <el-button
                class="danger"
                type="text"
                @click="remove(scope.row.id)"
                icon="el-icon-delete"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menuList: []
    };
  },
  methods: {
    remove(id) {
      let _id = id;
      this.$confirm("此操作将删除当前菜单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$ajax({
            loading: true,
            url: "/menu/delete",
            data: {
              id: _id
            }
          }).then(data => {
            this.$util.msg(data.msg, "success");
            setTimeout(() => {
              this.getMenuList();
            }, 1200);
          });
        })
        .catch(() => {});
    },
    getMenuList() {
      this.$ajax({
        loading: true,
        url: "/menu/index"
      }).then(data => {
        this.menuList = data.data;
      });
    }
  },
  mounted() {
    this.getMenuList();
  }
};
</script>
<style>
</style>